module.exports = __webpack_public_path__ + "b2a6341ae7440130ec4b4b186aff8413.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Regular.woff2
// module id = 342
// module chunks = 0